import * as Yup from 'yup';

export const flashMessagesSchema = Yup.object({
  session: Yup.object({
    flashMessages: Yup.array()
      .min(1, 'flashMessages must have at least one item')
      .required(),
  }).required(),
}).required();
